import AdminRegistrationWizard from "../../../../components/auth/AdminRegistrationWizard";

export default function AdminRegisterPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-dark-primary p-4 relative">
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-20 -left-20 w-72 h-72 rounded-full bg-golden-accent/10 blur-3xl" />
        <div className="absolute -bottom-24 -right-20 w-80 h-80 rounded-full bg-golden-accent/5 blur-3xl" />
      </div>

      <div className="relative w-full max-w-6xl flex rounded-2xl ring-1 ring-dark-border/60 shadow-2xl overflow-hidden bg-dark-secondary/70 backdrop-blur-xl">
        <div className="w-full md:w-3/5 flex flex-col justify-center p-8 md:p-12">
          <div className="flex items-center mb-8">
            <img src="/G1.svg" alt="Logo" className="w-10 h-10 mr-3" />
            <span className="text-2xl font-bold tracking-tight text-text-primary">Livelong Wealth</span>
          </div>
          <AdminRegistrationWizard />
        </div>

        <div className="hidden md:flex flex-col items-center justify-center w-2/5 bg-gradient-to-br from-dark-tertiary to-dark-secondary p-10 text-text-primary relative">
          <div className="absolute inset-0 flex items-center justify-center opacity-30">
            <div className="w-72 h-72 rounded-full border border-dark-border/60" />
            <div className="absolute w-44 h-44 rounded-full border border-dark-border/50" />
          </div>
          <div className="relative flex flex-col items-start gap-6">
            <h2 className="text-3xl font-extrabold leading-tight">Launch Your Admin Workspace</h2>
            <ul className="space-y-3 text-sm text-text-secondary">
              <li>1. Select platforms: Slack, Discord, Telegram</li>
              <li>2. Configure your login credentials</li>
              <li>3. Receive onboarding email confirmation</li>
              <li>4. Set up tokens in Settings to go live</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
